import { combineReducers } from 'redux';

import scenariosListReducer from '../scenariosList/store/reducer';
import scenarioMembersReducer from '../scenarioMemberList/store/reducer';
import scenarioReportReducer from '../scenarioReport/store/reducer';
import scenariosSharedReducer from '../shared/store/reducer';
import scenarioEditDetailsReducer from '../scenarioEditDetails/store/reducer';


const scenariosReducer = combineReducers({
  shared: scenariosSharedReducer,
  list: scenariosListReducer,
  members: scenarioMembersReducer,
  report: scenarioReportReducer,
  details: scenarioEditDetailsReducer,
});


export default scenariosReducer;
